var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoWithdrawal24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.001,
    height: 18,
    viewBox: "0 0 18.001 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Withdrawals",
    transform: "translate(-64.111 -28.281)",
    fill: "#00a1af"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48386",
    "data-name": "Path 48386",
    d: "M82.11,30.47v-.311a1.851,1.851,0,0,0-1.822-1.878H65.936a1.85,1.85,0,0,0-1.823,1.878v.313Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48535",
    "data-name": "Path 48535",
    d: "M64.113,31.688v8.2A1.924,1.924,0,0,0,65.935,41.9h2.88a2.22,2.22,0,0,1,.484-.847,2.262,2.262,0,0,1,1.658-.721,2.3,2.3,0,0,1,.462.047V37.454a2.259,2.259,0,0,1,4.517,0v2.811a2.232,2.232,0,0,1,.463-.048,2.26,2.26,0,0,1,1.66.726,2.217,2.217,0,0,1,.512.957h1.716a1.923,1.923,0,0,0,1.822-2.011v-8.2Zm5.874,4.329a.587.587,0,0,1-.562.608H66.133a.586.586,0,0,1-.563-.608V34.21a.587.587,0,0,1,.563-.607h3.292a.587.587,0,0,1,.562.607Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48537",
    "data-name": "Path 48537",
    d: "M76.934,41.891a.717.717,0,0,0-1.071,0L74.436,43.43V37.454a.761.761,0,1,0-1.517,0v6.089l-1.426-1.538a.719.719,0,0,0-1.072,0,.863.863,0,0,0,0,1.157l2.668,2.878a.717.717,0,0,0,1.072,0l2.773-2.992A.863.863,0,0,0,76.934,41.891Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoWithdrawal24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_withdrawal24x24.903e090041044d7f25cd4bbee7f270f8.svg";